// Shared role constants for both user-management UI and the role-override
// (view-as) feature. Mirrors ROLE_PRIORITY in netlify/functions/utils/admin.js
// so the frontend never offers a role the backend doesn't recognize.

export const KNOWN_ROLES = [
  'admin',
  'sales_manager',
  'ops',
  'legal',
  'finance',
  'science',
  'leadership',
  'sales',
  'user',
  'calculator',
];

export const ROLE_CONFIG = {
  user: { label: 'User', color: 'bg-gray-100 text-gray-600' },
  calculator: { label: 'Calculator', color: 'bg-blue-100 text-blue-700' },
  sales: { label: 'Sales', color: 'bg-gray-100 text-gray-600' },
  sales_manager: { label: 'Sales Manager', color: 'bg-amber-100 text-amber-700' },
  ops: { label: 'Ops', color: 'bg-orange-100 text-orange-700' },
  legal: { label: 'Legal', color: 'bg-ae-info-bg text-ae-aqua-700' },
  finance: { label: 'Finance', color: 'bg-yellow-100 text-yellow-700' },
  science: { label: 'Science', color: 'bg-ae-red-100 text-ae-red-700' },
  leadership: { label: 'Leadership', color: 'bg-ae-info-bg text-ae-aqua-700' },
  admin: { label: 'Admin', color: 'bg-activ-teal-light text-activ-teal' },
};

// The subset shown in the user-management UI's role picker. `science` is
// managed elsewhere (it's a workflow-internal role).
export const ROLE_OPTIONS = [
  'user',
  'calculator',
  'sales',
  'sales_manager',
  'ops',
  'legal',
  'finance',
  'leadership',
  'admin',
];

export function getRoleLabel(role) {
  return ROLE_CONFIG[role]?.label || role;
}
